module.exports = __webpack_public_path__ + "img/icon_login.614ce6bb.svg";